(function(root, factory) {

    // NOTE: Adapted from: https://github.com/umdjs/umd/blob/master/templates/returnExports.js
    // Until we move the webpack, we still need to use the amd format for core's r.js
    // The client side doesn't really need lazy string, but RRS would throw an error during
    // checksum validation if client side code doesn't match server side
    if (typeof define === 'function' && define.amd) {
        define([], function() { // eslint-disable-line prefer-arrow-callback
            return factory();
        });
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    }

})(this, function() { // eslint-disable-line babel/no-invalid-this, prefer-arrow-callback
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator,
        FAUX_ITERATOR_SYMBOL = '@@iterator';

    /**
     * GenericLazyString is a constructor function that will create instances of objects whose toString method will
     * resolve the provided 'translateFn'. It is intended to be used in situation where you declare a string, for example,
     * at the top level of an ES6 module, but you do not need its value until later in your application lifecyle. A good use
     * case of this, will be translations, where you might declare a literal string in a constants file but you won't know the
     * language the user prefers until later in the loading process of your application.
     *
     * @param {Function} translateFn a function without arguments to be called whenever toString of a GenericLazyString instance is called.
     */
    function GenericLazyString(translateFn) {
        this.prototype = Object.create(String.prototype);

        this.toString = function() {
            return translateFn();
        };

        /**
         * We save the msgid here so that Jest's snapshot tests can assert on the string passed in.
         * Also, removing this would be a breaking change given this is looked at in many tests.
         *
         * Lastly, this is used to ensure that we are a valid LazyString
         */
        this.__msgid = this.toString();

        // EB-64381: We need to override the iterator because React thinks that the lazy string object
        // is an array-like object and would render each string individually
        // https://github.com/facebook/react/blob/master/src/renderers/shared/stack/reconciler/traverseStackChildren.js
        // React uses `FAUX_ITERATOR_SYMBOL` when `Symbol.iterator` doesn't exist (IE) so we
        // should be covered in all environments.
        // https://github.com/facebook/react/blob/e932ad68bed656eed5295b61ba74e5d0857902ed/src/isomorphic/children/ReactChildren.js#L22-L23
        this[ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL] = function() {
            this._called = false;

            return {
                next: function() {
                    if (!this._called) {
                        this._called = true;
                        return {value: this.toString()};
                    }

                    return {done: true};
                }.bind(this),
            };
        };

    }

    /**
     * isValid checks if a provided object can be used as a valid GenericLazyString
     */
    GenericLazyString.isValid = function(obj) {
        return obj !== 'undefined' && typeof obj.__msgid !== 'undefined';
    };

    return GenericLazyString;
});
